/* 
 * Export component file to be used on project
*/

import ProfessionalListItem from './ProfessionalListItem.js';
export default ProfessionalListItem;
